export default __webpack_public_path__ + "./fonts/0d4ec08dc6b105c09ea2f98b104ee5be.woff2";